import Tooltip from "rc-tooltip";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import DOMPurify from 'dompurify';
import { Colors } from "../colors/colors";




const Handle = Slider.Handle;


const {
  primaryColor,
  lightGrayColor
} = Colors();


export const RatingScale = ({ label, min, max, defaultValue, onChange, value }) => {

  const handle = (props) => {
    const { value, dragging, index, ...restProps } = props;
    return (
      <Tooltip
        prefixCls="rc-slider-tooltip"
        overlay={value}
        visible={true}
        placement="top"
        key={index}
      >
        <Handle value={value} {...restProps} />
      </Tooltip>
    );
  };

  const marks = {};
  for (let i = min; i <= max; i++) {
    marks[i] = i.toString();
  }

  return (
    <div className="">
      <p className="mb-6" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(label) }} />
      <div style={{ padding: "0 10px" }}>
        <Slider
          min={min}
          max={max}
          defaultValue={defaultValue}
          handle={handle}
          marks={marks}
          onChange={onChange}
          railStyle={{ height: 8, backgroundColor: lightGrayColor }}
          trackStyle={{ height: 8, backgroundColor: primaryColor }}
          handleStyle={{
            borderColor: primaryColor,
            height: 15,
            width: 15,
            marginTop: -4,
          }}
          dotStyle={{
            borderColor: primaryColor,
            bottom: -4,
          }}
        />
      </div>
      <div style={{
        margin: "1.5rem 0"
      }}>Rated: {value}</div>
    </div>
  );
};

export default RatingScale;